import React, { memo } from 'react';

import { PieChart, Pie, Cell } from 'recharts';
import * as Styles from './styles';

interface IProps {
  inDebt: boolean;
  isDebit: boolean;
  progress: any;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HoursBarComponent: React.FC<IProps> = ({ inDebt, isDebit, progress = {} }) => {
  console.log(progress.saldo);
  const hourHired = progress.saldo.slice(0, -6);

  const minuteHired =
    progress.contratada[2] === ':'
      ? Number(progress.saldo.slice(3, 5))
      : Number(progress.contratada.slice(4, 6));

  const hourSpent =
    progress.consumida[2] === ':'
      ? Number(progress.consumida.slice(0, 2))
      : Number(progress.consumida.slice(0, 3));

  const saldoString = progress.saldo.replace('-', '');

  const balance =
    saldoString[2] === ':' ? Number(saldoString.slice(0, 2)) : Number(saldoString.slice(0, 3));

  const COLORS = [inDebt ? '#B23B85' : '#60DFDB', '#7E225A'];

  return (
    <Styles.Container style={{ display: 'flex', justifyContent: 'center' }}>
      {hourHired <= 0 && (minuteHired <= 0 || Number.isNaN(minuteHired)) ? (
        <p>Não há horas contratadas.</p>
      ) : (
        <>
          <span style={{ color: inDebt ? '#7E225A' : '#60DFDB' }}>
            {hourHired} <br />
            <small> horas</small>
          </span>
          <span style={{ color: inDebt ? '#7E225A' : '#60DFDB' }}>
            {minuteHired} <br />
            <small>minutos</small>
          </span>

          <PieChart width={400} height={190}>
            <Pie
              width={'500px'}
              data={[
                {
                  name: 'Saldo',
                  value: progress.saldo[0] === '-' ? balance : balance,
                },
                {
                  name: 'Gasto',
                  value: hourSpent,
                },
                {
                  outro: 'different',
                  value: hourSpent < 0 ? Math.abs(hourSpent) : 0,
                },
              ]}
              cx={195}
              cy={80}
              innerRadius={60}
              outerRadius={80}
              dataKey="value"
            >
              {[
                {
                  name: 'Saldo',
                  value: progress.saldo[0] === '-' ? balance : balance,
                },
                {
                  name: 'Gasto',
                  value: hourSpent,
                },
                {
                  outro: 'different',
                  value: hourSpent < 0 ? Math.abs(hourSpent) : 0,
                },
              ].map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </>
      )}
    </Styles.Container>
  );
};

export const HoursBar = memo(HoursBarComponent);
